<template>
  <v-card>
    <v-card-title class="headline">
      Код драйвера для вставки
      <v-spacer></v-spacer>
      <v-btn icon class="mx-0" @click="$emit('close-dialog')"><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text class="mb-4">
      <p class="mb-0">Вставьте этот код в то место, где должен отображаться драйвер</p>
      <code>{{htmlCode}}</code>
      <p class="mb-0 mt-4">Затем поместите следующий код внутри тега <b>head</b> или <b>body</b></p>
      <code>{{script}}</code>
    </v-card-text>

  </v-card>
</template>

<script>
  export default {
    name : "CodeFrom",
  
    props:{
      data:{
        type: Object,
        required: true,
      },
    },
    
    data: () => ({
      htmlCode: '',
      script: ''
    }),
    
    mounted(){
      this.getCode(this.data)
    },
    
    methods:{
      getCode(data){
        switch(data.type){
          case 0:
            this.htmlCode = '<div id="dms-btn-widget"></div>'
            this.script = '<script src="https://dev18.dantser.net/static/widgets/dmsButton.js?id='+data.id+'"><'+'/script>'
            break
        }
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/apps/analytics_old/components/Drivers/Forms/CodeForm.vue